import { MapPin } from "lucide-react";
import { FadeUp, MaskLines, SectionLabel } from "./Reveal";
import { CITIES } from "@/lib/data";
import { useLang } from "@/lib/i18n";

export const Areas = () => {
  const { t } = useLang();
  const a = t.areas;
  return (
  <section id="areas" data-testid="areas-section" className="relative overflow-hidden bg-coal py-24 md:py-36">
    <img src="/img/boston.jpg" alt={a.imgAlt} className="absolute inset-0 h-full w-full object-cover opacity-[0.18]" />
    <div className="absolute inset-0 bg-gradient-to-b from-coal via-coal/70 to-coal" />
    <div className="relative mx-auto max-w-[1440px] px-5 md:px-10">
      <SectionLabel n="07">{a.label}</SectionLabel>
      <h2 className="font-display mt-8 max-w-5xl text-4xl font-black uppercase leading-[0.92] text-bone sm:text-5xl lg:text-6xl">
        <MaskLines inView lines={[a.l1, <span key="g">{a.l2a} <span className="font-serif-i normal-case text-brand">{a.l2b}</span></span>]} />
      </h2>
      <FadeUp>
        <div className="mt-14 flex flex-wrap gap-x-3 gap-y-3">
          {CITIES.map((c, i) => (
            <span key={c} data-testid={`area-${c.toLowerCase()}`} className={`inline-flex items-center gap-2 border px-4 py-2.5 transition-colors duration-300 hover:border-brand hover:text-bone ${i === 0 ? "border-brand bg-brand/10 text-bone" : "border-white/10 text-zinc-300"}`}>
              <MapPin className="h-3.5 w-3.5 text-brand" />
              <span className="font-mono text-[12px] uppercase tracking-[0.14em]">{c}</span>
            </span>
          ))}
          <span className="inline-flex items-center border border-dashed border-white/20 px-4 py-2.5 font-mono text-[12px] uppercase tracking-[0.14em] text-zinc-400">{a.others}</span>
        </div>
      </FadeUp>
    </div>
  </section>
  );
};
